import { Component, Inject, OnInit } from '@angular/core';
import { Environment } from 'src/typings';
import { EnvironmentToken } from 'src/util';
import { TalentHappyPathDataService } from "../shared/service/talent-happy-path-data-service";
import { TranslateService } from "@ngx-translate/core";
import {Gather} from "../../gather/gather-typings";
import { Countries } from "../../enums";
import { getJobBoardUrl } from "../shared/util/talent-happy-path-util";
import { ActivatedRoute } from '@angular/router';

const THP_CONTEXT = 'talent-happy-path.quick-apply';
const GATHER_CONTEXT = 'gather';
const THANK_YOU_TITLE = 'thank-you-page.title';
const THANK_YOU_MESSAGE = 'thank-you-page.message';
const THANK_YOU_BUTTON = 'thank-you-page.button';
const THANK_YOU_BUTTON_JP = 'thank-you-page.button-jp'
@Component({
  selector: 'app-thank-you',
  standalone: false,
  templateUrl: './thank-you.component.html',
  styleUrl: './thank-you.component.scss'
})
export class ThankYouComponent implements OnInit {
  postingInfo: PostingInfo;
  buttonURL: string;
  gather: Gather;
  isGather: boolean = false;
  titleText: string = String(this.translateService.instant(THP_CONTEXT.concat('.').concat(THANK_YOU_TITLE)));
  messageText: string = String(this.translateService.instant(THP_CONTEXT.concat('.').concat(THANK_YOU_MESSAGE)));
  buttonText: string;
  constructor(@Inject(EnvironmentToken) private environment: Environment,
              private talentHappyPathDataService: TalentHappyPathDataService,
              protected translateService: TranslateService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    const isFromVmsSubmittal = this.route.snapshot.queryParamMap.get('from') === 'vms-submittal';
    this.postingInfo = this.talentHappyPathDataService.postingInfo;
    if (this.postingInfo.countryId != Countries.JP) {
      this.buttonText = String(this.translateService.instant(THP_CONTEXT.concat('.').concat(THANK_YOU_BUTTON)));
      this.buttonURL = this.environment.matHost;
    } else {
      this.buttonText = String(this.translateService.instant(THP_CONTEXT.concat('.').concat(THANK_YOU_BUTTON_JP)));
      this.buttonURL = getJobBoardUrl(Countries.JP);
    }
    this.gather = this.talentHappyPathDataService.gather;
    if (this.gather && this.gather.gatherId) {
      this.isGather = true;
      this.setGatherVmsThankYouContent();
    } else if (isFromVmsSubmittal) {
      this.setGatherVmsThankYouContent();
    }
  }

  private setGatherVmsThankYouContent() {
    this.titleText = String(this.translateService.instant(GATHER_CONTEXT.concat('.').concat(THANK_YOU_TITLE)));
    this.messageText = String(this.translateService.instant(GATHER_CONTEXT.concat('.').concat(THANK_YOU_MESSAGE)));
    this.buttonText = String(this.translateService.instant(GATHER_CONTEXT.concat('.').concat(THANK_YOU_BUTTON)));
  }
}
